import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { MessageTemplate } from '../../models/enums/enums';
import { AdditionalInformation } from '../../models/enums/additionalInformation';
export interface NotificationData {
  image: string,
  name: string,
  message: string,
  route: string
}
@Injectable({
  providedIn: 'root'
})
export class PushNotificationService {

  constructor() { }

  notificationData: any;

  notification$ = new Subject<NotificationData>();

  pushNotification(message: string, messageTemplate: MessageTemplate, data: { [key: string]: any }) {
    this.notificationData = data;
    const notification: NotificationData = {
      image: data?.['image'] ?? '../../../assets/images/default-profile.png',
      name: data?.['name'] ?? 'User',
      message: message || '',
      route: this.getRoute(messageTemplate) || ''
    };
    this.notification$.next(notification);
  }

  getRoute(messageTemplate: MessageTemplate): string {
    if (this.notificationData?.['routing']?.['route']) {
      return this.notificationData['routing']['route'];
    }
    return '';
  }
}
